import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { merge } from 'lodash';
import { InsuranceTypesEnum, tInsuranceTypeEnum } from '@models/InsuranceType';
import { PaymentMethods } from '@models/PaymentInfo';
import { selectCurrentUser, selectIsHospital } from '@components/Auth';
import { selectHealthPolicyClaim } from './selector';
import { FormValues, formValuesSchema } from './schema';

export const useInitialValues = () => {
  const { policy, insurancePolicyUser } = useSelector(selectHealthPolicyClaim);
  const currentUser = useSelector(selectCurrentUser);
  const isHospital = useSelector(selectIsHospital);
  const initialValues: FormValues = formValuesSchema.getDefault() as unknown as FormValues;

  return useMemo(() => {
    merge(initialValues, {
      coveredByOtherInsurance: '',
      totalClaimedAmount: '',
      policyHolder: insurancePolicyUser?.user?.name ?? '',
      policyHolderDob: insurancePolicyUser?.user?.dob ?? '',
      policyHolderGender: insurancePolicyUser?.user?.gender ?? '',
      policyNumber: policy?.policyNumber ?? '',
      policyPlanType: `${tInsuranceTypeEnum((policy?.insuranceType as InsuranceTypesEnum) ?? '')} - ${insurancePolicyUser?.benefitTemplate.name ?? ''}`,
      policyExpiryDate: insurancePolicyUser?.expirationDate ?? '',
      mobileNumber: isHospital ? currentUser.mobileNumber : (insurancePolicyUser?.user?.mobileNumber ?? ''),
      email: isHospital ? currentUser.email : (insurancePolicyUser?.user?.email ?? ''),
      businessPartnerId: isHospital ? currentUser.businessPartner.id : '',
      paymentInfo: {
        beneficiaryName: isHospital ? currentUser.businessPartner.name : (insurancePolicyUser?.user?.name ?? ''),
        paymentMethod: PaymentMethods.BankTransfer,
        bankName: isHospital ? currentUser.businessPartner.bankName : '',
        bankAccount: isHospital ? currentUser.businessPartner.bankAccountNumber : '',
      },
    });

    return initialValues;
  }, [policy, insurancePolicyUser]);
};
